var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable } from 'rxjs/Observable';
import { CurrentOrderService } from './currentOrder.service';
import { TranslateService } from '@ngx-translate/core';
import { MixpanelService } from './../mixpanel/mixpanel.service';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Config } from '../config/config';
import '../../rxjs-operator';
import * as moment from 'moment';
import { LocalStorageService } from '../localstorage.service';
var OrderService = (function () {
    function OrderService(http, mixpanel, translate, currentOrderService, localStorage) {
        var _this = this;
        this.http = http;
        this.mixpanel = mixpanel;
        this.translate = translate;
        this.currentOrderService = currentOrderService;
        this.localStorage = localStorage;
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        //private inviteUrl: string = '/Mailings';  // URL to web api
        this.uploadUrl = '/upload'; //URL to web api
        this.padToSeven = function (number) { return number <= 9999999 ? ("000000" + number).slice(-7) : number.toString(); };
        this.padToThree = function (number) { return number <= 999 ? ("00" + number).slice(-3) : number.toString(); };
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.apiBaseUrl = Config.getEnvironmentVariable("apiBaseUrl");
        this.graphEndpoint = Config.getEnvironmentVariable("graphEndpoint");
        this.getBrands();
        this.getCountries();
    }
    OrderService.prototype.getOrdersList = function () {
        var _this = this;
        var request = "{\n      requests{\n        id\n        createdAt\n        items{\n          id\n        }\n        promoCode\n        orderType\n        purchaseOrderNumber\n        isPartialDelivery\n        isBillingAddressSame\n        courierName\n        shippingMethod\n        firstName\n        lastName\n        jobTitle\n        phone\n        email\n        companyName\n        shipping_line\n        shipping_city\n        shipping_country\n        shipping_state\n        shipping_postalcode\n        billing_line\n        billing_city\n        billing_country\n        billing_state\n        billing_postalcode\n        brand\n        status\n      }\n    }";
        return this.http.post(this.apiBaseUrl + this.graphEndpoint, { query: request }, { headers: this.createAutorizationHeader() })
            .map(function (results) {
            var ret = [];
            var res = results.json();
            if (res.errors) {
                return Observable.throw("Query error");
            }
            else {
                res.data.requests.forEach(function (request) {
                    ret.push(_this.requestFromGraphQL(request));
                });
                return ret;
            }
        });
    };
    OrderService.prototype.getOrder = function (requestId) {
        var _this = this;
        var request = "query request($id:Int){\n      request(id:$id){\n        id\n        createdAt\n        previous\n        next\n        items{\n          id\n          partNumber\n          description\n          qty\n          note\n          drawingNum\n          thirdItemNum\n          uom\n          fileName\n          fileURL\n          brand\n        }\n        promoCode\n        orderType\n        purchaseOrderNumber\n        isPartialDelivery\n        isBillingAddressSame\n        courierName\n        otherCourierName\n        courierAccountNumber\n        deliveryMethod\n        shippingMethod\n        firstName\n        lastName\n        jobTitle\n        phone\n        email\n        companyName\n        shipping_line\n        shipping_city\n        shipping_country\n        shipping_state\n        shipping_postalcode\n        billing_line\n        billing_city\n        billing_country\n        billing_state\n        billing_postalcode\n        brand\n        status\n        poFileName\n        poFileKey\n        poFileURL\n        questionComment\n      }\n    }";
        var vars = { id: requestId };
        return this.http.post(this.apiBaseUrl + this.graphEndpoint, { query: request, variables: vars }, { headers: this.createAutorizationHeader() })
            .map(function (results) {
            var res = results.json();
            if (res.errors)
                return Observable.throw("Query error");
            return _this.requestFromGraphQL(res.data.request);
        });
    };
    OrderService.prototype.createAutorizationHeader = function () {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + this.localStorage.getItem("token"));
        return headers;
    };
    OrderService.prototype.buildUptimeId = function (orderId, itemId) {
        if (itemId === void 0) { itemId = null; }
        var result = "WEB-" + this.padToSeven(orderId);
        if (itemId)
            result += "-" + this.padToThree(itemId);
        return result;
    };
    OrderService.prototype.requestFromGraphQL = function (request) {
        var items = [];
        request.items.forEach(function (element) {
            items.push({
                PartNumber: element.partNumber,
                Description: element.description,
                Qty: element.qty,
                Note: element.note,
                ThirdItemNum: element.thirdItemNum,
                DrawingNum: element.drawingNum,
                Uom: element.uom,
                file: null,
                fileName: element.fileName,
                fileKey: element.fileKey,
                fileURL: element.fileURL,
                brand: element.brand
            });
        });
        return {
            id: request.id,
            uptimeId: this.buildUptimeId(request.id),
            previous: request.previous,
            next: request.next,
            Items: items,
            createdAt: request.createdAt,
            PromoCode: request.promoCode,
            orderType: request.orderType,
            PurchaseOrderNumber: request.purchaseOrderNumber,
            POfile: null,
            POfileName: request.poFileName,
            POfileKey: request.poFileKey,
            POfileURL: request.poFileURL,
            IsPartialDelivery: request.isPartialDelivery,
            IsBillingAddressSame: request.isBillingAddressSame,
            QuestionComment: request.questionComment,
            CourierName: request.courierName,
            OtherCourierName: request.otherCourierName,
            CourierAccountNumber: request.courierAccountNumber,
            DeliveryMethod: request.deliveryMethod,
            ShippingMethod: request.shippingMethod,
            Brand: {
                Id: "",
                Name: request.brand,
                Order: 0
            },
            Status: {
                Id: "",
                Name: request.status
            },
            ShippingAddress: {
                Line: request.shipping_line,
                City: request.shipping_city,
                Country: {
                    Id: "",
                    Name: request.shipping_country,
                    ShortName: "",
                },
                StateProvince: request.shipping_state,
                PostalCode: request.shipping_postalcode,
                TypeId: null,
                AccountId: null
            },
            BillingAddress: {
                Line: request.billing_line,
                City: request.billing_city,
                Country: {
                    Id: "",
                    Name: request.billing_country,
                    ShortName: "",
                },
                StateProvince: request.billing_state,
                PostalCode: request.billing_postalcode,
                TypeId: null,
                AccountId: null
            },
            Contact: {
                FirstName: request.firstName,
                LastName: request.lastName,
                JobTitle: request.jobTitle,
                Phone: request.phone,
                Email: request.email,
                AccountId: null,
                CompanyName: request.companyName
            }
        };
    };
    OrderService.prototype.getBrands = function () {
        var _this = this;
        if (!this.brands) {
            var request = "\n      {\n          brands{\n            Id\n            Name\n            Order\n          }\n      }\n      ";
            this.brands = this.http.post(this.apiBaseUrl + this.graphEndpoint, { query: request })
                .publishReplay(1).refCount()
                .map(function (res) {
                var body = res.json();
                return body.data.brands || {};
            })
                .catch(function (error) {
                _this.brands = null;
                return Observable.throw(error);
            });
        }
        return this.brands;
    };
    OrderService.prototype.getCountries = function () {
        var _this = this;
        if (!this.countries) {
            var request = "\n      {\n          countries{\n            Id\n            Name\n            ShortName\n          }\n      }\n      ";
            this.countries = this.http.post(this.apiBaseUrl + this.graphEndpoint, { query: request })
                .publishReplay(1).refCount()
                .map(function (res) {
                var body = res.json();
                return body.data.countries || {};
            })
                .catch(function (error) {
                _this.countries = null;
                return Observable.throw(error);
            });
        }
        return this.countries;
    };
    OrderService.prototype.addOrder = function (order, culture) {
        this.mixpanel.api.track(this.orderType.lowercaseType + " completed", {
            "pt_brand": order.Brand.Name,
            "pt_courier_name": order.CourierName,
            "pt_delivery_method": order.DeliveryMethod,
            "pt_other_courier_name": order.OtherCourierName,
            "pt_partial_delivery": order.IsPartialDelivery,
            "pt_shipping_city": order.ShippingAddress.City,
            "pt_shipping_country": order.ShippingAddress.Country.Name,
            "pt_shipping_method": order.ShippingMethod,
            "pt_shipping_province": order.ShippingAddress.StateProvince,
            "pt_promo_code": order.PromoCode,
            "pt_shipping_add": order.ShippingAddress.Line,
            "pt_po": order.PurchaseOrderNumber,
            "pt_isBillingAddressSame": order.IsBillingAddressSame,
            "pt_CourierAccountNumber": order.CourierAccountNumber,
            "pt_isQuestionCommented": order.QuestionComment ? order.QuestionComment.length > 0 : false,
            "pt_ItemsNumber": order.Items.length,
            "pt_language": this.translate.currentLang,
            "pt_isItemFileAttached": order.Items.filter(function (item) { return item.fileName ? true : false; }).length,
            "pt_isDuplicateItems": order.Items.filter(function (item) { return item.isDuplicate; }).length,
            "pt_isPOFileAttached": order.POfileName ? true : false,
        });
        var submitDate = moment().format('YYYY-MM-DD hh:mm:ss a');
        var mutation = "mutation requestCreate(\n      $request: RequestInput\n    ){\n      requestCreate(request:$request,culture:\"" + culture + "\",date:\"" + submitDate + "\"){\n        id\n      }\n    }\n    ";
        var items = [];
        order.Items.forEach(function (element) {
            items.push({
                partNumber: (element.PartNumber ? element.PartNumber : ""),
                description: (element.Description ? element.Description : ""),
                qty: (element.Qty),
                note: (element.Note ? element.Note : ""),
                drawingNum: (element.DrawingNum ? element.DrawingNum : ""),
                thirdItemNum: (element.ThirdItemNum ? element.ThirdItemNum : ""),
                uom: (element.UOM ? element.UOM : ""),
                fileName: (element.fileName ? element.fileName : null),
                fileKey: (element.fileKey ? element.fileKey : null),
                fileURL: (element.fileURL ? element.fileURL : null),
                isDuplicate: (element.isDuplicate ? element.isDuplicate : false),
                brand: (element.brand ? element.brand : ""),
            });
        });
        var vars = { request: {
                promoCode: (order.PromoCode ? order.PromoCode : ""),
                orderType: (order.orderType ? order.orderType : ""),
                purchaseOrderNumber: (order.PurchaseOrderNumber ? order.PurchaseOrderNumber : ""),
                isPartialDelivery: (order.IsPartialDelivery),
                isBillingAddressSame: (order.IsBillingAddressSame),
                courierName: (order.CourierName ? order.CourierName : ""),
                otherCourierName: (order.OtherCourierName ? order.OtherCourierName : ""),
                courierAccountNumber: (order.CourierAccountNumber ? order.CourierAccountNumber : ""),
                shippingMethod: (order.ShippingMethod ? order.ShippingMethod : ""),
                deliveryMethod: (order.DeliveryMethod ? order.DeliveryMethod : ""),
                questionComment: (order.QuestionComment ? order.QuestionComment : ""),
                firstName: (order.Contact.FirstName ? order.Contact.FirstName : ""),
                lastName: (order.Contact.LastName ? order.Contact.LastName : ""),
                jobTitle: (order.Contact.JobTitle ? order.Contact.JobTitle : ""),
                phone: (order.Contact.Phone ? order.Contact.Phone : ""),
                email: (order.Contact.Email ? order.Contact.Email : ""),
                companyName: (order.Contact.CompanyName ? order.Contact.CompanyName : ""),
                shipping_line: (order.ShippingAddress.Line ? order.ShippingAddress.Line : ""),
                shipping_city: (order.ShippingAddress.City ? order.ShippingAddress.City : ""),
                shipping_country: (order.ShippingAddress.Country.Name ? order.ShippingAddress.Country.Name : ""),
                shipping_state: (order.ShippingAddress.StateProvince ? order.ShippingAddress.StateProvince : ""),
                shipping_postalcode: (order.ShippingAddress.PostalCode ? order.ShippingAddress.PostalCode : ""),
                billing_line: (order.BillingAddress.Line ? order.BillingAddress.Line : ""),
                billing_city: (order.BillingAddress.City ? order.BillingAddress.City : ""),
                billing_country: (order.BillingAddress.Country.Name ? order.BillingAddress.Country.Name : ""),
                billing_state: (order.BillingAddress.StateProvince ? order.BillingAddress.StateProvince : ""),
                billing_postalcode: (order.BillingAddress.PostalCode ? order.BillingAddress.PostalCode : ""),
                brand: (order.Brand.Name ? order.Brand.Name : ""),
                status: (order.Status.Name ? order.Status.Name : ""),
                poFileName: (order.POfileName ? order.POfileName : null),
                poFileKey: (order.POfileKey ? order.POfileKey : null),
                poFileURL: (order.POfileURL ? order.POfileURL : null),
                items: items
            } };
        var options = new RequestOptions({ headers: this.headers });
        var token = this.localStorage.getItem('token');
        if (token) {
            this.headers.set('authorization', "Bearer " + token);
        }
        return this.http.post(this.apiBaseUrl + this.graphEndpoint, { query: mutation, variables: vars }, options).toPromise()
            .catch(this.handleError);
    };
    OrderService.prototype.addMixpanelProfile = function (order, orderType) {
        this.mixpanel.api.identify(order.Contact.Email);
        this.mixpanel.api.people.set({
            "company": order.Contact.CompanyName,
            "$first_name": order.Contact.FirstName,
            "$last_name": order.Contact.LastName,
            "$email": order.Contact.Email
        });
    };
    OrderService.prototype.handleError = function (error) {
        var errMsg = (error._body) ? JSON.parse(error._body) :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        return Promise.reject(errMsg);
    };
    OrderService.generateUUID = function () {
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    };
    OrderService.prototype.getCountryFromName = function (countryName) {
        return this.countries.subscribe(function (countries) { return countries.find(function (element) { return element.Name == countryName; }); });
    };
    OrderService.prototype.getBrandFromName = function (brandName) {
        return this.brands.subscribe(function (brands) { return brands.find(function (element) { return element.Name == brandName; }); });
    };
    OrderService.prototype.buildTimestamp = function () {
        var date = new Date();
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var timestamp = year + month + day;
        return timestamp;
    };
    OrderService.prototype.getToken = function (file) {
        return this.http.post(this.apiBaseUrl + this.uploadUrl, JSON.stringify({ "filename": file.name, "content_type": file.type, 'folder': this.order.id }))
            .toPromise()
            .catch(this.handleError);
    };
    OrderService.prototype.sendFile = function (result, file) {
        return new Promise((function (resolve, reject) {
            var formData = new FormData();
            var xhr = new XMLHttpRequest();
            var params = JSON.parse(result['_body']).params;
            var url = JSON.parse(result['_body']).endpoint_url;
            formData.append('key', params.key);
            formData.append('acl', 'public-read');
            formData.append('Content-Type', file.type);
            formData.append('X-Amz-Credential', params['x-amz-credential']);
            formData.append('X-Amz-Algorithm', 'AWS4-HMAC-SHA256');
            //formData.append('X-Amz-uuid',''); //uncomment to simulate an error on upload
            formData.append('X-Amz-Date', this.buildTimestamp() + 'T000000Z');
            formData.append('Policy', params['policy']);
            formData.append('X-Amz-Signature', params['x-amz-signature']);
            formData.append('file', file);
            xhr.open('POST', url, true);
            xhr.onload = function () {
                if (199 < xhr.status && xhr.status < 300) {
                    console.log('File uploaded');
                    resolve({ key: params.key, url: url });
                }
                else {
                    console.log('Something went wong');
                    reject();
                }
            };
            xhr.onerror = function () {
                reject();
            };
            xhr.send(formData);
        }).bind(this));
    };
    OrderService.prototype.uploadFile = function (file) {
        var _this = this;
        return this.getToken(file)
            .then(function (result) { return _this.sendFile(result, file); })
            .catch(this.handleError);
    };
    OrderService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Http,
            MixpanelService,
            TranslateService,
            CurrentOrderService,
            LocalStorageService])
    ], OrderService);
    return OrderService;
}());
export { OrderService };
//# sourceMappingURL=order.service.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.service.js
// module id = 25
// module chunks = 0